import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { cookRequestParams } from '@/common/request'

export function getGmakerGrantList(params) {
  return request({
    url: `${v2Host}/gmaker/grant/list`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

export function saveGmakerGrant(data) {
  return request({
    url: `${v2Host}/gmaker/grant/save`,
    method: 'post',
    data,
  })
}

/**
 * 获取金额
 * @param {*} data
 * @returns
 */
export function getGmakerGrantRevenue(data, withoutError = false) {
  return request({
    url: `${v2Host}/gmaker/grant/revenue`,
    method: 'post',
    data,
    withoutError,
  })
}

export function getGmakerGrantInfo(params) {
  return request({
    url: `${v2Host}/gmaker/grant/info`,
    method: 'get',
    params,
  })
}

export function getGmakerGrantDetail(params) {
  return request({
    url: `${v2Host}/gmaker/grant/details`,
    method: 'get',
    params,
  })
}

export function updateGrantStatus(data) {
  return request({
    url: `${v2Host}/gmaker/grant/update-status`,
    method: 'post',
    data,
  })
}
